var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Banners',{attrs:{"v-if":this.sessionId && this.sessionBanners,"banners":this.sessionBanners}})
}
var staticRenderFns = []

export { render, staticRenderFns }